import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { radius } from "src/design/tokens";

/** Where a record or assignment came from. `manual` and `school` both mean the school added it. */
export type RecordSource = "roster" | "manual" | "school";

export interface SourceBadgeProps {
  source: RecordSource;
}

/** "Roster" or "Added by school", on the chip token pairs `StatusChip` uses. */
export const SourceBadge = ({ source }: SourceBadgeProps) => {
  const { t } = useTranslation();
  const fromRoster = source === "roster";

  return (
    <Box
      component="span"
      data-source={fromRoster ? "roster" : "manual"}
      sx={(theme) => ({
        display: "inline-flex",
        alignItems: "center",
        px: "9px",
        py: "4px",
        borderRadius: `${radius.pill}px`,
        bgcolor: fromRoster
          ? theme.palette.primary.light
          : theme.palette.surfaceAlt,
        color: fromRoster
          ? theme.palette.primaryInk
          : theme.palette.text.primary,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      })}
    >
      {fromRoster ? t("people.source.roster") : t("people.source.manual")}
    </Box>
  );
};

export default SourceBadge;
